// ============================================================
//  GALERIE DE PROJETS — MODIFIEZ FACILEMENT ICI
//  Chaque projet possède :
//   - title    : nom du projet
//   - category : catégorie affichée (Intérieur, Extérieur, Global)
//   - cover    : photo de couverture (carte principale)
//   - description : court texte présenté dans la galerie du projet
//   - photos   : liste des photos du projet (galerie individuelle)
//  Ajoutez / retirez simplement des URL dans "photos" pour chaque projet.
// ============================================================

const A = "https://customer-assets.emergentagent.com/job_design-showcase-1404/artifacts";

export const galleryProjects = [
  {
    title: "Villa Lumière",
    key: "villa",
    categoryKey: "interieur",
    category: "Design Intérieur",
    description:
      "Une résidence privée où la lumière naturelle sculpte des volumes épurés et intemporels, de la façade aux circulations intérieures.",
    cover: `${A}/z3u3h0sp_IMG_5394.jpg`,
    beforeAfter: {
      before: `${A}/c616bkuz_20160826_153007%20%282021_07_21%2016_02_45%20UTC%29.webp`,
      after: `${A}/0ssvyy1f_20171017_140256.webp`,
    },
    photos: [
      `${A}/z3u3h0sp_IMG_5394.jpg`,
      `${A}/0ssvyy1f_20171017_140256.webp`,
      `/gallery/villa_p3.jpg`,
      `${A}/c616bkuz_20160826_153007%20%282021_07_21%2016_02_45%20UTC%29.webp`,
      `${A}/reodv303_20171109_115407%20%282021_07_21%2016_02_45%20UTC%29.webp`,
    ],
  },
  {
    title: "ALBERT 1er",
    key: "albert",
    categoryKey: "global",
    category: "Design Global",
    description:
      "Une rénovation complète, du gros œuvre à l'aménagement final : transformation d'un espace sous combles en un intérieur chaleureux et contemporain, du croquis initial au résultat livré.",
    cover: `${A}/2jgk247a_20140219_145024%20%282021_07_21%2016_02_45%20UTC%29%20-%20Copy.webp`,
    beforeAfter: {
      before: `/gallery/proj2_demolition.jpg`,
      after: `/gallery/proj2_cabinet.jpg`,
      fit: "contain",
    },
    photos: [
      `/gallery/proj2_demolition.jpg`,
      `/gallery/albert_sketch.jpg`,
      `${A}/a5aq2vuw_20140219_144955%20%282021_07_21%2016_02_45%20UTC%29%20-%20Copy.webp`,
      `/gallery/proj2_cabinet.jpg`,
      `${A}/2jgk247a_20140219_145024%20%282021_07_21%2016_02_45%20UTC%29%20-%20Copy.webp`,
    ],
  },
  {
    title: "2PM",
    key: "deuxpm",
    categoryKey: "global",
    category: "Design Global",
    description:
      "Une identité complète, orchestrée du concept à la réalisation dans une cohérence absolue : jeux de lumière indirecte, matières nobles et détails maîtrisés.",
    cover: `/gallery/proj3_facade.jpg`,
    photos: [
      `${A}/8akly6o7_20171107_220205%20%282021_07_21%2016_02_45%20UTC%29.jpg`,
      `/gallery/proj3_facade.jpg`,
      `/gallery/2pm_p3.jpg`,
      `/gallery/2pm_p4.jpg`,
      `${A}/u0u9o8b1_20171107_220416%20%282021_07_21%2016_02_45%20UTC%29.webp`,
    ],
  },
];
